import {SET_MIDI_MAP_MODE} from 'constants/action-types.js';
import {SET_PARAMETER_MIDI_MAP_SELECTION} from 'constants/action-types.js';
import {SET_PARAMETER_MIDI_MAPPING} from 'constants/action-types.js';
import {MAP, DELETE, OFF} from 'constants/midi-map-modes.js';
import {DELETE_PARAMETER_MIDI_MAPPING} from 'constants/action-types.js';
import {SET_ACTION_MIDI_MAP_SELECTION} from 'constants/action-types.js';
import {SET_ACTION_MIDI_MAPPING} from 'constants/action-types.js';
import {DELETE_MIDI_MAPPINGS} from 'constants/action-types.js';
import {SET_LAST_MIDI_CC_PLAYED} from 'constants/action-types.js';

let initialState = {
    midiMapMode: OFF,
    parameterSelected: undefined,
    mappings: {},
    actionSelected: undefined,
    actionMappings: {},
    lastMidiCCPlayed: undefined,
};

const midiReducer = (state = initialState, action) => {
    let newState;
    let midiControl;
    let midiMappings;
    let actionMappings; 
    switch (action.type) {
    case SET_LAST_MIDI_CC_PLAYED:
        return {
            ... state,
            lastMidiCCPlayed: action.payload
        };
    case SET_MIDI_MAP_MODE:
        return {
            ... state,
            midiMapMode: action.payload,
            parameterSelected: undefined,
            actionSelected: undefined
        };
    case SET_PARAMETER_MIDI_MAP_SELECTION:
        return {
            ... state,
            actionSelected: undefined,
            parameterSelected: action.payload
        };
    case SET_ACTION_MIDI_MAP_SELECTION:
        return {
            ... state,
            parameterSelected: undefined,
            actionSelected: action.payload
        };
    case SET_PARAMETER_MIDI_MAPPING:
        midiMappings = {
            ... state.mappings,
        };

        // parameter is an id (todo: ensure that saving a sequence
        // saves the id)
        midiControl = action.payload.midiControl;
        if (midiMappings[midiControl] === undefined) {
            midiMappings[midiControl] = [];
        }
        midiMappings[midiControl].push(action.payload.parameter);

        return {
            ... state,
            mappings: midiMappings,
        };
    case SET_ACTION_MIDI_MAPPING:
        actionMappings = {
            ... state.actionMappings,
        };

        // parameter is an id (todo: ensure that saving a sequence
        // saves the id)
        midiControl = action.payload.midiControl;
        if (actionMappings[midiControl] === undefined) {
            actionMappings[midiControl] = [];
        }
        actionMappings[midiControl].push(action.payload.action);

        return {
            ... state,
            actionMappings: actionMappings,
        };
    case DELETE_PARAMETER_MIDI_MAPPING:
        let mappings = {};
        let parameterId = action.payload;
        for (let control in state.mappings) {
            let mappingForControl = state.mappings[control];
            let i = mappingForControl.indexOf(parameterId);
            if (i > -1) {
                mappingForControl.splice(i, 1);
            }
            if (mappingForControl.length > 0) {
                mappings[control] = mappingForControl;
            }
        }

        return {
            ... state,
            mappings: mappings,
            parameterSelected: undefined,
            midiMapMode: OFF,
        }
    case DELETE_MIDI_MAPPINGS:
        actionMappings = {
            ... state.actionMappings,
        };
        midiMappings = {
            ... state.mapping
        };

        delete actionMappings[action.payload];
        delete midiMappings[action.payload];

        return {
            ... state,
            mappings: midiMappings,
            actionMappings: actionMappings,
        };
    default:
        return state;
    }
}

export default midiReducer;
